import * as React from "react";
import { Button } from "components/bootstrap";
import { Icon } from "components/common";
const PlusButton = ({ onClick, disabled = false, title }) => /* @__PURE__ */ React.createElement(Button, { bsSize: "small", onClick, disabled }, /* @__PURE__ */ React.createElement(Icon, { name: "add" }), " ", title);
export default PlusButton;
